export default {
    title: 'Learn how this trend may impact your business',
    createButton: 'Create as post',
    aiExplanationTextContent: {
        textPostfix: '?',
        textPlaceholder: 'please select/enter',
        selectHeader: 'please select or use input field',
        textPrefix: 'What\'s the impact of this macro-trend on '
    },
    disclaimer: 'The results are generated by artificial intelligence and are primarily used for inspiration. We recommend an individual assessment of the relevance and plausibility of these contents.'
}
